import React from 'react';
import EventManager from '../../../common/services/event-manager.service';
import Modal from '../modal/modal.component';
import { navigateTo } from '../../utils/app.utils';
import appConfig from '../../../config/config';
import Button from 'b2b-ui-components-lib/lib/components/button';
/**
 *  Shows Service Error Modal
 *
 * @class ServiceErrorModal
 * @extends {React.PureComponent}
 */
class ServiceErrorModal extends React.PureComponent {
  state = {
    show: false,
    data: null
  };

  /**
   * Closes service error modal
   *
   * @memberof ServiceErrorModal
   */
  onErrorModalClose = () => {
    EventManager.publish('serviceError', { show: false });
    if (document && document.body) {
      document.body.className = '';
    }
    if (this.state.redirect) {
      navigateTo(appConfig.dedicatedhomePageUrl);
    }
  };

  /**
   * Adds listener for service errors
   *
   * @memberof ServiceErrorModal
   */
  addServiceErrorListener() {
    EventManager.subscribe('serviceError', (errorModal) => {
      this.setState(
        {
          show: errorModal.show,
          data: errorModal.data,
          redirect: errorModal.redirect
        },
        () => {
          if (document && document.body && this.state.show) {
            var orig = document.body.className;
            document.body.className = orig + (orig ? ' ' : '') + 'no-scroll';
          }
        }
      );
    });
  }

  /**
   * React [componentDidMount] hook adds listener
   *
   * @memberof ServiceErrorModal
   */
  componentDidMount() {
    this.addServiceErrorListener();
  }

  render() {
    return (
      <Modal type="CUSTOM" show={this.state.show}>
        <div className="modal">
          <div className="modal-content">
            <div className="modal-header">
              <h4>We're Sorry</h4>
            </div>
            <div className="modal-body">
              {this.state.data ? (
                <p>{this.state.data}</p>
              ) : (
                <p>An unexpected error has occurred. Our technical staff has been automatically notified and will be looking into this with utmost urgency.</p>
              )}
            </div>
            <div className="modal-footer">
              <div className="action" align="right">
                {/* <button type="button" className="btn activebtn" onClick={this.onErrorModalClose}>Ok. Got It!</button> */}
                <Button onClick={this.onErrorModalClose} displayName="Ok. Got It!"></Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ServiceErrorModal;
